const MILLION = 1000000;

export default function () {
	return function (price) {
		if (price) {
			let value = price / MILLION;
			return ("" + value).replace('.', ',');
		} else {
			return ' - ';
		}
	};
}
